"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileTitleAndText = exports.Tile = exports.TileStyle = exports.TileIconPosition = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconSizes_1 = require("../Icons/PropTypes/IconSizes");
const Icons_1 = require("../Icons");
var TileIconPosition;
(function (TileIconPosition) {
    TileIconPosition["Center"] = "center";
    TileIconPosition["Top"] = "top";
})(TileIconPosition = exports.TileIconPosition || (exports.TileIconPosition = {}));
var TileStyle;
(function (TileStyle) {
    TileStyle["Default"] = "default";
    TileStyle["Button"] = "button";
})(TileStyle = exports.TileStyle || (exports.TileStyle = {}));
/** Used to keep the Title and Text styling for the Tile component but allows for more customization */
const TileTitleAndText = ({ title, text }) => {
    if (!title && !text)
        return null;
    return (react_1.default.createElement("div", { className: "gerudo-tile-info" },
        title && react_1.default.createElement("div", { className: "title" }, title),
        text && react_1.default.createElement("div", { className: "text" }, text)));
};
exports.TileTitleAndText = TileTitleAndText;
/** Tile Component. Used for small pieces of information with simple actions. Contains an exported `TileTitleAndText` component for further customization */
const Tile = (0, react_1.forwardRef)((_a, ref) => {
    var { icon, title, text, children, className: customClassName = "", iconPosition = TileIconPosition.Center, onClick, onClose, tileStyle = TileStyle.Default } = _a, props = __rest(_a, ["icon", "title", "text", "children", "className", "iconPosition", "onClick", "onClose", "tileStyle"]);
    const className = (0, classnames_1.default)(customClassName, "gerudo-tile", {
        "gerudo-tile-clickable": Boolean(onClick),
        "gerudo-tile-button": tileStyle === TileStyle.Button,
    });
    const isIconCentered = iconPosition === TileIconPosition.Center;
    const iconClassName = (0, classnames_1.default)("gerudo-tile-icon", {
        "gerudo-tile-icon-center": isIconCentered,
        "gerudo-tile-icon-top": !isIconCentered,
    });
    const showIcon = Boolean(onClose || icon);
    const onKeyDown = (e) => {
        if (onClick && (e.key === "Enter" || e.key === "Spacebar" || e.key === "Space" || e.key === " ")) {
            onClick();
        }
    };
    const clickableProps = onClick
        ? {
            role: "button",
            tabIndex: 0,
            onKeyDown,
            onClick,
        }
        : {};
    return (react_1.default.createElement("div", Object.assign({ ref: ref, className: className }, clickableProps, props),
        react_1.default.createElement(TileTitleAndText, { title: title, text: text }),
        children,
        showIcon && (react_1.default.createElement("div", { className: iconClassName },
            onClose && !icon && react_1.default.createElement(Icons_1.CancelIcon, { size: IconSizes_1.IconSizes.Xsmall, onClick: onClose }),
            icon))));
});
exports.Tile = Tile;
Tile.displayName = "Tile";
exports.default = Tile;
//# sourceMappingURL=Tile.js.map